import type { ListBuilderList } from '../../../types';
import { createTripColumnsWithDate } from '../columns';

/**
 * Open Trips — the landing view for the Trips page.
 *
 * Every trip still to be run or still being run. Finished work — completed,
 * cancelled and failed — is excluded, because it accumulates forever and
 * pushes today's runs off the screen. On Motor City Ice two thirds of the
 * trip list was finished work going back months, which is what prompted the
 * request to be able to delete trips.
 *
 * Statuses are enumerated rather than excluded because the status filter takes
 * an include list. When a new lifecycle status is added it must be added here
 * too, or trips in that state will silently drop off this view.
 *
 * Sorted oldest scheduled date first, so the nearest run — including anything
 * overdue — is at the top and the rest of the week reads downward.
 */
export const openTripsList: ListBuilderList = {
	id: 'open-trips',
	name: 'Open',
	type: 'default',
	active: true,
	cacheTTL: 600000,
	filterRules: {
		routeStatus: {
			// Hidden: the tab name IS the filter. Surfacing six status chips in
			// the active-filter bar wrapped onto two rows and told the operator
			// nothing the word "Open" doesn't. Someone who wants one specific
			// status wants All Trips plus the Status chip. Mirrors the
			// purchase-order-receipts "Recent" tab.
			hidden: true,
			defaultValue: [
				{ id: 'pending_load', label: 'Pending Load' },
				{ id: 'pending_pre_trip_wm_review', label: 'Pending Pre-Trip Review' },
				{ id: 'scheduled', label: 'Scheduled' },
				{ id: 'in-progress', label: 'In Progress' },
				{ id: 'pending_driver_confirm', label: 'Pending Driver Confirm' },
				{
					id: 'pending_post_trip_wm_review',
					label: 'Pending Post-Trip Review',
				},
			],
		},
	},
	columns: createTripColumnsWithDate(),
	defaultSortId: 'date-asc',
	sortOrder: 0,
};
